/* Section produit CNC — logique (asset). Générique : lit data-* sur .cnc-section */
(function(){
  function init(root){
    if(!root || root.dataset.cncInit) return;
    root.dataset.cncInit = '1';
    var cfg = {
      buy: root.getAttribute('data-buy-label') || 'Acheter maintenant',
      sold: root.getAttribute('data-soldout-label') || 'Épuisé',
      unavailable: root.getAttribute('data-unavailable-label') || 'Indisponible',
      currency: root.getAttribute('data-currency') || 'EUR',
      shipProgress: root.getAttribute('data-ship-progress') || '',
      shipSuccess: root.getAttribute('data-ship-success') || ''
    };
    var slides = root.querySelector('[data-cnc-slides]');
    var thumbs = root.querySelectorAll('[data-cnc-thumb]');
    function money(cents){
      try { return new Intl.NumberFormat('fr-FR',{style:'currency',currency:cfg.currency}).format(cents/100); }
      catch(e){ return (cents/100).toFixed(2)+' €'; }
    }
    function slideTo(i){
      if(!slides) return;
      var s = slides.querySelectorAll('[data-cnc-slide]');
      if(!s[i]) return;
      slides.scrollTo({left: s[i].offsetLeft - slides.offsetLeft, behavior:'smooth'});
      thumbs.forEach(function(t){ t.setAttribute('aria-current', t.getAttribute('data-cnc-thumb')==String(i)?'true':'false'); });
    }
    function currentIndex(){
      if(!slides) return 0;
      var s = slides.querySelectorAll('[data-cnc-slide]'), idx=0, min=Infinity;
      s.forEach(function(el,i){ var d=Math.abs(el.offsetLeft - slides.scrollLeft - slides.offsetLeft); if(d<min){min=d;idx=i;} });
      return idx;
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ slideTo(parseInt(t.getAttribute('data-cnc-thumb'),10)); }); });
    var prev = root.querySelector('[data-cnc-prev]'), next = root.querySelector('[data-cnc-next]');
    if(prev) prev.addEventListener('click', function(){ slideTo(Math.max(0,currentIndex()-1)); });
    if(next) next.addEventListener('click', function(){ var n=slides.querySelectorAll('[data-cnc-slide]').length; slideTo(Math.min(n-1,currentIndex()+1)); });
    if(slides) slides.addEventListener('scroll', function(){ var i=currentIndex(); thumbs.forEach(function(t){ t.setAttribute('aria-current', t.getAttribute('data-cnc-thumb')==String(i)?'true':'false'); }); }, {passive:true});

    /* Lightbox */
    var lb = root.querySelector('[data-cnc-lb]'), lbImg = root.querySelector('[data-cnc-lbimg]');
    root.querySelectorAll('.cnc-slide img[data-cnc-zoomsrc]').forEach(function(img){
      img.addEventListener('click', function(){ if(!lb) return; lbImg.src=img.getAttribute('data-cnc-zoomsrc'); lb.classList.add('open'); document.body.style.overflow='hidden'; });
    });
    function closeLb(){ if(lb){ lb.classList.remove('open'); document.body.style.overflow=''; } }
    if(lb){
      root.querySelector('[data-cnc-lbclose]').addEventListener('click', closeLb);
      lb.addEventListener('click', function(e){ if(e.target===lb || e.target===lbImg) closeLb(); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeLb(); });
      var zoomed=false;
      lbImg.addEventListener('click', function(e){ e.stopPropagation(); zoomed=!zoomed; lbImg.style.transform=zoomed?'scale(1.8)':'none'; lbImg.style.cursor=zoomed?'zoom-out':'zoom-in'; });
    }

    /* Variantes */
    var variants=[];
    try { variants = JSON.parse(root.querySelector('[data-cnc-variants]').textContent); } catch(e){}
    var selected = variants.filter(function(v){ return v.available; })[0] || variants[0];
    var priceEl = root.querySelector('[data-cnc-price]');
    var compareEl = root.querySelector('[data-cnc-compare]');
    var savePill = root.querySelector('[data-cnc-savepill]');
    var saveBadge = root.querySelector('[data-cnc-savebadge]');
    var buyBtn = root.querySelector('[data-cnc-buy]');
    var buyLabel = root.querySelector('[data-cnc-buylabel]');

    function getSelectedVariant(){
      var chosen={};
      root.querySelectorAll('input[data-cnc-opt]:checked').forEach(function(inp){ chosen[parseInt(inp.getAttribute('data-cnc-opt'),10)]=inp.value; });
      var keys=Object.keys(chosen);
      if(keys.length===0) return variants[0];
      return variants.find(function(v){ return keys.every(function(k){ return v.options[k]===chosen[k]; }); });
    }
    function updateOptLabels(){
      root.querySelectorAll('input[data-cnc-opt]:checked').forEach(function(inp){
        var idx=inp.getAttribute('data-cnc-opt');
        var lbl=root.querySelector('[data-cnc-optval="'+idx+'"]');
        if(lbl) lbl.textContent=inp.value;
      });
    }
    function render(v){
      if(!v){ if(buyBtn) buyBtn.setAttribute('disabled','disabled'); if(buyLabel) buyLabel.textContent=cfg.unavailable; return; }
      selected=v;
      if(priceEl) priceEl.textContent=money(v.price);
      if(compareEl){
        if(v.compare_at_price && v.compare_at_price>v.price){
          compareEl.textContent=money(v.compare_at_price); compareEl.hidden=false;
          var pct=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
          if(savePill){ savePill.textContent='-'+pct+'%'; savePill.hidden=false; }
          if(saveBadge) saveBadge.hidden=false;
        } else { compareEl.hidden=true; if(savePill) savePill.hidden=true; if(saveBadge) saveBadge.hidden=true; }
      }
      if(buyBtn){ if(v.available) buyBtn.removeAttribute('disabled'); else buyBtn.setAttribute('disabled','disabled'); }
      updateShip();
    }
    function refreshBuyLabel(v){ if(buyLabel && v) buyLabel.textContent = v.available ? cfg.buy : cfg.sold; }

    root.querySelectorAll('input[data-cnc-opt]').forEach(function(inp){
      inp.addEventListener('change', function(){
        updateOptLabels();
        var v=getSelectedVariant();
        render(v); refreshBuyLabel(v);
        if(v && v.featured_media){
          var s = slides ? slides.querySelectorAll('[data-cnc-slide]') : [];
          for(var i=0;i<s.length;i++){ if(s[i].getAttribute('data-media-id')==String(v.featured_media.id)){ slideTo(i); break; } }
        }
      });
    });

    /* Quantité */
    var qtyInput = root.querySelector('[data-cnc-qty]');
    var qtyMinus = root.querySelector('[data-cnc-qtyminus]');
    var qtyPlus = root.querySelector('[data-cnc-qtyplus]');
    function qty(){ return Math.max(1, parseInt(qtyInput?qtyInput.value:'1',10)||1); }
    if(qtyMinus) qtyMinus.addEventListener('click', function(){ qtyInput.value=Math.max(1,qty()-1); updateShip(); });
    if(qtyPlus) qtyPlus.addEventListener('click', function(){ qtyInput.value=qty()+1; updateShip(); });
    if(qtyInput) qtyInput.addEventListener('input', updateShip);

    /* Barre livraison (si présente) */
    var shipEl = root.querySelector('[data-cnc-ship]');
    function updateShip(){
      if(!shipEl) return;
      var threshold=parseInt(shipEl.getAttribute('data-threshold'),10)||0;
      var total=(selected?selected.price:0)*qty();
      var fill=shipEl.querySelector('[data-cnc-shipfill]');
      var msg=shipEl.querySelector('[data-cnc-shipmsg]');
      if(threshold<=0){ if(fill) fill.style.width='100%'; return; }
      var pct=Math.min(100,Math.round(total*100/threshold));
      if(fill) fill.style.width=pct+'%';
      if(msg){
        if(total>=threshold){ msg.innerHTML=cfg.shipSuccess; }
        else { msg.innerHTML=cfg.shipProgress.replace('[amount]','<strong>'+money(threshold-total)+'</strong>'); }
      }
    }

    /* Achat direct -> checkout */
    function doCheckout(){
      if(!selected) return;
      buyBtn.classList.add('is-loading'); buyBtn.setAttribute('disabled','disabled');
      fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:selected.id,quantity:qty()}) })
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.href='/checkout'; })
        .catch(function(){ window.location.href='/cart/'+selected.id+':'+qty(); });
    }
    if(buyBtn) buyBtn.addEventListener('click', doCheckout);

    var addBtn = root.querySelector('[data-cnc-add]');
    if(addBtn) addBtn.addEventListener('click', function(){
      if(!selected) return;
      addBtn.textContent='...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:selected.id,quantity:qty()})})
        .then(function(r){return r.json();})
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ window.location.href='/cart'; });
    });

    render(selected); refreshBuyLabel(selected); updateOptLabels(); updateShip();

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('cnc-in'); io.unobserve(e.target); } });
    }, {threshold:0.08});
    root.querySelectorAll('.cnc-anim').forEach(function(el){ io.observe(el); });

    initReviewsAutoscroll(root);
  }

  function initReviewsAutoscroll(root){
    var track = root.querySelector('.cnc-reviews');
    if(!track) return;
    var mq = window.matchMedia('(max-width:749px)');
    var timer = null, paused = false, resume = null;
    function cards(){ return track.querySelectorAll('.cnc-review'); }
    function step(){
      if(paused || !mq.matches) return;
      var list = cards(); if(list.length < 2) return;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if(atEnd){ track.scrollTo({left:0, behavior:'smooth'}); return; }
      var i = 0, best = Infinity;
      list.forEach(function(c, idx){ var d = Math.abs(c.offsetLeft - track.scrollLeft); if(d < best){ best = d; i = idx; } });
      var next = list[Math.min(i + 1, list.length - 1)];
      track.scrollTo({left: next.offsetLeft, behavior:'smooth'});
    }
    function start(){ if(timer) return; timer = setInterval(step, 4500); }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function pause(){ paused = true; clearTimeout(resume); resume = setTimeout(function(){ paused = false; }, 8000); }
    ['touchstart','pointerdown','wheel'].forEach(function(ev){ track.addEventListener(ev, pause, {passive:true}); });
    function sync(){ if(mq.matches) start(); else stop(); }
    (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));
    sync();
  }
  function boot(){ document.querySelectorAll('.cnc-section[data-cnc-root]').forEach(init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})()
